import { Toaster } from 'react-hot-toast';

export default function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#141B2D',
          color: '#fff',
          border: '1px solid #1E2A45',
          borderRadius: '10px',
          fontFamily: 'Rajdhani, sans-serif',
          fontSize: '14px',
          fontWeight: 600,
          maxWidth: '380px',
        },
        success: {
          iconTheme: { primary: '#00C896', secondary: '#141B2D' },
          style: { borderLeft: '3px solid #00C896' },
        },
        error: {
          iconTheme: { primary: '#FF3B3B', secondary: '#141B2D' },
          style: { borderLeft: '3px solid #FF3B3B' },
        },
        loading: {
          iconTheme: { primary: '#1E90FF', secondary: '#141B2D' },
          style: { borderLeft: '3px solid #1E90FF' },
        },
      }}
    />
  );
}
